<div class="card-slider-container">
  @if (!disabledArrows) {
    <div class="card-slider-nav" [ngClass]="{ show: showArrows }">
      <button
        class="btn btn-slider btn-next"
        [inlineSVG]="'/icons/icon-next.svg'"
        (click)="changeSlide('next')"
      ></button>
      <button
        class="btn btn-slider btn-prev"
        [inlineSVG]="'/icons/icon-prev.svg'"
        (click)="changeSlide('prev')"
      ></button>
    </div>
  }
  @if (breakpoints) {
    <div class="card-slider">
      <ngx-glide
        [type]="'slider'"
        [showArrows]="false"
        [showBullets]="showBullets"
        [dragThreshold]="false"
        [breakpoints]="breakpoints"
        [swipeThreshold]="15"
        [bound]="true"
      >
        @for (item of items; track item) {
          <div class="slide">
            <div class="slide-container">
              @if (type === 'category') {
                <lib-card-category [category]="item"></lib-card-category>
              }
              @if (type === 'photo') {
                <lib-card-photo [img]="item" (itemClicked)="onItemClick($event)"></lib-card-photo>
              }
              @if (type === 'broadcast') {
                <lib-card-broadcast [broadcast]="item"></lib-card-broadcast>
              }
              @if (type === 'event') {
                <lib-card-event (itemClicked)="onItemClick($event)" [event]="item"></lib-card-event>
              }
              @if (type === 'product') {
                <lib-card-product
                  [product]="item"
                  [shop]="item.shops[0]"
                  [displayShopName]="true"
                  [slider]="true"
                ></lib-card-product>
              }
            </div>
          </div>
        }
      </ngx-glide>
    </div>
  }
</div>
